// @ts-nocheck
/**
 * ファンド一覧コンポーネント
 * 地域ファンド、メタファンド、カテゴリファンドの一覧表示
 */

import React from 'react';
import { FUND_TYPES, REGION_FUNDS } from '../data/funds';
import { getAvailableFunds } from '../systems/portfolioManager';
import { getInformant, getInformantComment } from '../data/informants';
import { useIsMobile } from '../../hooks/useMediaQuery';

const RegionFunds = ({
  investmentData,
  onSelectFund,
  fundType = FUND_TYPES.REGION,
  title = '地域ファンド',
  description = '各地域の情勢に連動するファンドです',
  marketIndex,
  marketState,
}) => {
  const isMobile = useIsMobile();
  const funds = getAvailableFunds(investmentData, fundType, marketIndex, marketState);

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    },
    header: {
      marginBottom: '8px',
    },
    title: {
      fontSize: '16px',
      fontWeight: 'bold',
      color: '#e0e0e0',
      marginBottom: '4px',
    },
    description: {
      fontSize: '12px',
      color: '#888',
    },
    fundList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    fundCard: {
      display: 'flex',
      alignItems: 'center',
      padding: isMobile ? '12px' : '16px',
      backgroundColor: '#16213e',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'all 0.2s',
      border: '1px solid transparent',
    },
    fundCardHover: {
      borderColor: '#4fc3f7',
      backgroundColor: '#1a2744',
    },
    fundIcon: {
      fontSize: isMobile ? '24px' : '32px',
      marginRight: '12px',
    },
    fundInfo: {
      flex: 1,
      minWidth: 0,
    },
    fundName: {
      fontSize: isMobile ? '14px' : '16px',
      fontWeight: 'bold',
      color: '#e0e0e0',
      marginBottom: '4px',
    },
    fundDescription: {
      fontSize: '12px',
      color: '#888',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    fundInformant: {
      fontSize: '11px',
      color: '#4fc3f7',
      marginTop: '4px',
      fontStyle: 'italic',
    },
    fundPriceSection: {
      textAlign: 'right',
      minWidth: isMobile ? '80px' : '100px',
    },
    fundPrice: {
      fontSize: isMobile ? '14px' : '16px',
      fontWeight: 'bold',
      color: '#e0e0e0',
    },
    fundChange: {
      fontSize: '12px',
      marginTop: '2px',
    },
    fundChangePositive: {
      color: '#4caf50',
    },
    fundChangeNegative: {
      color: '#f44336',
    },
    fundChangeNeutral: {
      color: '#888',
    },
    badges: {
      display: 'flex',
      gap: '4px',
      marginTop: '4px',
      justifyContent: 'flex-end',
    },
    badge: {
      fontSize: '10px',
      padding: '2px 6px',
      borderRadius: '4px',
    },
    badgeHot: {
      backgroundColor: '#f44336',
      color: '#fff',
    },
    badgeCold: {
      backgroundColor: '#2196f3',
      color: '#fff',
    },
    badgeHolding: {
      backgroundColor: '#4caf50',
      color: '#fff',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.title}>{title}</div>
        <div style={styles.description}>{description}</div>
      </div>

      <div style={styles.fundList}>
        {funds.map((fund) => {
          const informant = fund.informantId ? getInformant(fund.informantId) : null;
          const informantComment = informant
            ? getInformantComment(fund.informantId, fund.priceChange)
            : null;

          return (
            <div
              key={fund.id}
              style={styles.fundCard}
              onClick={() => onSelectFund(fund)}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#4fc3f7';
                e.currentTarget.style.backgroundColor = '#1a2744';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'transparent';
                e.currentTarget.style.backgroundColor = '#16213e';
              }}
            >
              <div style={styles.fundIcon}>{fund.icon}</div>

              <div style={styles.fundInfo}>
                <div style={styles.fundName}>{fund.name}</div>
                <div style={styles.fundDescription}>{fund.description}</div>
                {informantComment && (
                  <div style={styles.fundInformant}>
                    {informant.icon} 「{informantComment}」
                  </div>
                )}
              </div>

              <div style={styles.fundPriceSection}>
                <div style={styles.fundPrice}>
                  {fund.currentPrice.toLocaleString()}G/口
                </div>
                <div
                  style={{
                    ...styles.fundChange,
                    ...(fund.priceChange > 0
                      ? styles.fundChangePositive
                      : fund.priceChange < 0
                      ? styles.fundChangeNegative
                      : styles.fundChangeNeutral),
                  }}
                >
                  {fund.priceChange > 0 ? '+' : ''}
                  {fund.priceChange.toFixed(1)}%
                </div>
                <div style={styles.badges}>
                  {fund.isHot && (
                    <span style={{ ...styles.badge, ...styles.badgeHot }}>🔥HOT</span>
                  )}
                  {fund.isCold && (
                    <span style={{ ...styles.badge, ...styles.badgeCold }}>❄️COLD</span>
                  )}
                  {fund.isHolding && (
                    <span style={{ ...styles.badge, ...styles.badgeHolding }}>
                      保有{fund.holdingUnits}口
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RegionFunds;
